import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { AUTOMATION_PATHS, BACK_URL_KEY } from '@/src/modules/AutomationModuleNew/constants';

export const useNavigateAndBack = (backKey: string = BACK_URL_KEY) => {
  const navigate = useNavigate();

  const hasBackUrl = sessionStorage.getItem(backKey) !== null;

  const navigateAndSavePathname = useCallback(
    (to: string) => {
      sessionStorage.setItem(backKey, window.location.pathname);
      navigate(to);
    },
    [backKey, navigate]
  );

  const getBackUrlAndRemoveSS = useCallback(() => {
    const backUrl = sessionStorage.getItem(backKey) || `/v2/${AUTOMATION_PATHS.MODULE_PATH}`;
    sessionStorage.removeItem(backKey);
    return backUrl;
  }, [backKey]);

  const backUrl = sessionStorage.getItem(backKey);

  return { navigateAndSavePathname, getBackUrlAndRemoveSS, hasBackUrl, backUrl };
};
